import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/sagas/userMenu/userMenu";
import { Moon, Sun } from "../../../assets/images/svg";
import ToggleableButton from "../../../components/toggleableButton/toggleableButton";

export function ThemeToggle() {
  const dispatch = useDispatch();
  const lightTheme = useSelector((state) => state.userMenu.lightTheme);

  const toggleLightTheme = (isActive) => {
    const classNameToUpdate = isActive ? "light" : "dark";
    const classNameToRemove = isActive ? "dark" : "light";
    document.body.classList.remove(classNameToRemove);
    document.body.classList.add(classNameToUpdate);
    dispatch(actionCreators.updateThemePreferences(classNameToUpdate));
  };

  return (
    <li className="theme-toggle">
      <div className="theme-toggle__title">Mode</div>
      <div className="theme-toggle__main">
        <div className="theme-toggle__icon">
          <Moon />
        </div>
        <div className="theme-toggle__checkbox">
          <ToggleableButton
            isRadio
            title="theme"
            isActive={lightTheme}
            onClick={toggleLightTheme}
          />
        </div>
        <div className="theme-toggle__icon theme-toggle__icon-sun">
          <Sun />
        </div>
      </div>
    </li>
  );
}
